import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isSidebarOpen: false,
};

const app = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsSidebarOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isSidebarOpen = payload;
    },
  },
});

export const { setIsSidebarOpen } = app.actions;

export default app;
